import Content from './content';
import CSS from './Login.module.css';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import LogoImage from '@CS/assets/logo.png';

type LoginProps = { onLogin: () => void };

export const Login = ({ onLogin }: LoginProps) => {
  const { title, text, button } = useTranslation(Content);

  return (
    <section className={CSS.loginScreen} aria-label="Login">
      <img alt="Login" src={LogoImage} />

      <div className={CSS.infoContainer}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>

      <Button onClick={onLogin} text={button} />
    </section>
  );
};
